module.exports = __webpack_public_path__ + "img/hjjh.288f6417.jpg";